import React from "react";
import { DocumentComplianceDialog } from "../hse/compliance/DocumentComplianceDialog";

/**
 * DocumentAccessDialog — admin dialog «Tilgang og lesekrav» for one HMS document:
 * access rule (all employees / positions / selected people), people added manually,
 * access via training guides, and the read requirement (deadline + postponements).
 * Kept as the stable import path for existing callers.
 */
export const DocumentAccessDialog = ({ documentId, documentTitle, open, onClose, onSaved }) => (
  <DocumentComplianceDialog
    open={open}
    onClose={onClose}
    documentId={documentId}
    documentTitle={documentTitle}
    onSaved={onSaved}
  />
);

export default DocumentAccessDialog;
